<div class="section" style="width: 800px; height: 650px; flex: 1; display: flex; flex-direction: column;" data-cy="case-add-procedure">
  <div class="section-header" data-cy="case-add-procedure-header">
    <div class="section-header-title" data-cy="case-add-procedure-title">Add Procedure(s)</div>
  </div>
  <div class="section-content" style="display: flex; flex-direction: column; flex: 1;" data-cy="case-add-procedure-content">
    <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="case-add-procedure-spinner"></app-tdo-progress-spinner>
    <div *ngIf="!isLoading" style="height: 535px;" data-cy="case-add-procedure-table-container">
      <tdo-table [dataSource]="cfgCaseProcedures"
                 [isMultiSelection]="!isSingleSelection" [isSearchable]="true" [isUsePaginator]="true"
                 [searchPredicate]="searchPredicate" (rowSelected)="onRowSelected($event)"
                 data-cy="case-add-procedure-table">
        <tdo-table-column displayName="Procedure Name" propertyName="ProcedureName" isSortable="true" [rowTemplate]="procedurename" data-cy="case-add-procedure-column-name">
          <ng-template #procedurename let-row>
            <div *ngIf="row.ProcedureName" data-cy="case-add-procedure-procedure-name">{{ row.ProcedureName }}</div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Code" propertyName="Code" isSortable="true" [rowTemplate]="code" data-cy="case-add-procedure-column-code">
          <ng-template #code let-row>
            <div *ngIf="row.Code" data-cy="case-add-procedure-procedure-code">{{ row.Code }}</div>
          </ng-template>
        </tdo-table-column>
      </tdo-table>
    </div>

    <div class="action-container" data-cy="case-add-procedure-actions">
      <button class="tdo-button tdo-close" style="margin-right: 12px;" (click)="cancel(false)" data-cy="case-add-procedure-close-btn">Close</button>
      <button [disabled]="selectedCaseProcedure.length === 0" class="tdo-button tdo-save" style="margin-right: 12px;" (click)="saveProcedure()" data-cy="case-add-procedure-save-btn">Add Procedure(s)</button>

    </div>

  </div>
</div>




